export const SHADOW1 = '0px 5px 15px rgba(0, 0, 0, 0.05)';
export const INSET1 = 'inset 0px -1px 0px #e6e6e6';
export const INSET2 = 'inset 0px -1px 0px #3270C2';

export const BOX_SHADOW1 = '0px 1px 5px rgba(0, 0, 0, 0.07), inset 0px -1px 0px #E9E9E9';
export const BOX_SHADOW2 = '0px 2px 4px rgba(0, 0, 0, 0.05);';

export const WHITE = '#ffffff';
export const ALMOST_WHITE = '#FBFBFB';

export const ALMOST_BLACK = '#333333';

export const GREY1 = '#EBEBEB'; //border, grey1 in figma
export const GREY2 = '#f8f8f8'; //hover
export const GREY3 = '#9C9C9C'; //grey 1-2 in Figma
export const GREY4 = '#535353'; //grey 2 in Figma
export const GREY5 = '#f6f6f6'; //empty

export const MAIN = '#4C7FF0';
export const PINK = '#E633AE';
export const RED = '#DC5534';

export enum EWorldColor {
    BLUE = '3270C2',
    RED = 'CC4D36',
    GREEN = '64AE62',
    YELLOW = 'E6C529',
    PURPLE = '8D57B5',
    DARK1 = '313E50',
    DARK2 = '838C8D',
    BROWN = '82541C',
    ORANGE = 'D17F19',
    WHITE = 'ffffff',
    TRANSPARENT = '00000000'
}
